(function() {
    'use strict';

    angular.module('conferencesApp').controller('ContainerCtrl', function($scope, auth, WSAlert, CONFERENCES_APP_CODE, WORLDSKILLS_REGISTRATION_URL, WORLDSKILLS_CLIENT_ID, ENVIRONMENT_WARNING) {
        $scope.auth = auth;
        $scope.logout = function (e) {
            auth.logout();
        };
        $scope.date = new Date();
        $scope.registrationUrl = WORLDSKILLS_REGISTRATION_URL + '?client_id=' + encodeURIComponent(WORLDSKILLS_CLIENT_ID);
        $scope.$on('$stateChangeStart', function () {
            WSAlert.clear();
        });
        auth.hasUserRole(CONFERENCES_APP_CODE, 'Admin').then(function (hasUserRole) {
            if (hasUserRole) {
                $scope.userIsAdmin = true;
            }
        });
        $scope.environmentWarning = ENVIRONMENT_WARNING;
    });
})();
